import { useSelector } from 'react-redux';
import { RootState, UserDetailsState } from '../../types/redux';

export default function useUserDetails(): UserDetailsState | undefined {
  return useSelector((state: RootState): UserDetailsState => state.userDetails);
}
